<template>
<div class="c-dropdown-variations c-form__item">
    <template v-if="!disabled">
        <div @click="toggleDropdown">
            <div class="c-rect-input">
                <input :id="inputId" :class="{ 'has-value' : this.hasValue }" class="c-rect-input__input c-dropdown-variations__value-field" :value="(dataValue && dataValue.name) ? dataValue.name : ''" :type="type" ref="textvalue" :required="required ? 'required' : false" onkeydown="event.preventDefault()" />
                <label :for="inputId" class="c-rect-input__label" :data-required-suffix="this.requiredSuffix">{{label}}</label>
            </div>
        </div>
        <template v-if="showDropdown">
            <div class="c-dropdown-variations__content">
                <div class="c-dropdown-variations__search" v-if="filterable">
                    <input placeholder="Sök" @input="filterItems" ref="search" @keypress.enter.prevent="selectFirstOnEnter" />
                    <vue-icon name="search" size="c-icon--18px"></vue-icon>
                </div>
				<div v-if="resettable" class="c-dropdown-variations__item" @click="reset">
					{{resetOptionText}}
				</div>
                <collapse-transition>
                    <ul class="c-dropdown-variations__list" ref="dropdown">
                        <template v-for="itemGroup in filteredItems">
                            <li v-if="itemGroups.length > 1 && itemGroup.label" class="c-dropdown-variations__item-group-label">{{itemGroup.label}}</li>
                            <li v-for="item in itemGroup.items" class="c-dropdown-variations__item" @click="chooseItem(item)">
                                {{item.name}}
                            </li>
                        </template>
                        <li v-if="allowCustomValue && this.$refs.search" class="c-dropdown-variations__item" @click="chooseItem({ id: 'övrigt:'+$refs.search.value, group: 'Övrigt', name: $refs.search.value})"><span class="t-text-style-mu">Lägg till</span> {{$refs.search.value}}</li>
                    </ul>
                </collapse-transition>
            </div>
        </template>
    </template>
	<template v-if="disabled">
	    <div class="c-rect-input">
            <input :id="inputId" :class="{ 'has-value' : this.hasValue }" class="c-rect-input__input c-dropdown-variations__value-field" :value="(dataValue && dataValue.name) ? dataValue.name : ''" :type="type" ref="textvalue" :required="required ? 'required' : false" onkeydown="event.preventDefault()" disabled="disabled" />
            <label :for="inputId" class="c-rect-input__label">{{label}}</label>
        </div>
	</template>
</div>
</template>

<script>
import {
    CollapseTransition
} from 'vue2-transitions';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import clickOutside from '@/js/utils/vue-mixins/click-outside.js';
import Vue from 'vue';

export default {
    name: 'DropdownVariations',
    props: {
        inputId: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: Object,
            default: () => {}
        },
        required: {
            type: Boolean,
            default: true
        },
        itemGroups: {
            type: Array,
            default: () => []
        },
        filterable: {
            type: Boolean,
            default: false
        },
		resettable: {
			type: Boolean,
			default: false
		},
        allowCustomValue: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
		resetOptionText: {
			type: String,
			default: 'Visa alla'
		}
    },
    components: {
        VueIcon,
        CollapseTransition
    },
    mixins: [clickOutside],
    data() {
        return {
            showDropdown: false,
            filterQuery: '',
            dataValue: this.value
        }
    },
    computed: {
        hasValue() {
            return this.dataValue && this.dataValue.id;
        },
        filteredItems() {
            if (!this.filterQuery) {
                return this.itemGroups;
            }
            let filteredResult = this.itemGroups.map(itemGroup => {
                let filteredItems = itemGroup.items.filter(item => {
                    return item.name.toLowerCase().includes(this.filterQuery.toLowerCase());
                });
                if (filteredItems.length > 0) {
                    let filtered = {
                        items: filteredItems,
                        label: itemGroup.label
                    };
                    return filtered;
                } else {
                    return {};
                }
            });
            return filteredResult;
        },
        matches() {
            return this.filteredItems.reduce((acc, group) => {
                if (!group || !group.items) return acc + 0;
                return acc + group.items.length;
            }, 0);
        },
        requiredSuffix() {
            return this.required
                ? '*'
                : ''
        }
    },
    methods: {
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
            this.filterQuery = '';
            this.$nextTick(function () {
                if (this.showDropdown && this.filterable && this.$refs.search) {
                    this.$refs.search.focus();
                }
            });
        },
        chooseItem(item) {
            this.dataValue = item;
            this.showDropdown = false;
            this.filterQuery = '';
            this.$emit('selectedItem', this.dataValue);
        },
        getValue() {
            return this.dataValue;
        },
        filterItems(e) {
            let query = e.target.value;
            if (query.length > 1) {
                this.filterQuery = query;
            } else {
                this.filterQuery = '';
            }
        },
        selectFirstOnEnter() {
            let option = null;
            if (this.$refs.dropdown) {
                option = this.$refs.dropdown.querySelector('.c-dropdown-variations__item');
            }
            if (option) option.click();
        },
		reset() {
			this.dataValue = {};
			this.$emit('selectedItem', null);
			this.toggleDropdown();
		}
    },
	created() {
		this.$on('click-outside', function () {
			if(this.showDropdown) {
				this.toggleDropdown();
			}
		});
	}
};
</script>
